import imageUrlBuilder from '@sanity/image-url'
import { client } from '../lib/client'

const builder = imageUrlBuilder(client)

export function urlFor(source) {
  return builder.image(source)
}


export function getPreviewText(blocks, charLimit) {
    const text = blocks
        .map(block => 
            block.children?.map(child => child.text || "").join(" ") || ""
        )
        .join(" ");

    if (text.length <= charLimit) return text;
    return text.substring(0, charLimit) + "...";
}
